/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable max-depth */
/* eslint-disable no-await-in-loop */
import {
  Box,
  Button,
  Grid,
  TextareaAutosize,
  Typography,
  useTheme,
} from "@mui/material";
import { TypeCommon } from "models/common";
import { ReactElement, useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { t } from "i18next";
import { checkTimeListInWorkingHours, formatNumberWithCommas, normalizeFullwidthToHalfwidth, ToastMessage } from "utils/common.util";
import {
  NOTIFICATION_TYPE,
} from "constants/common.constant";
import Spinner from "components/spinner";
import { get, post, uploadImage } from "api/base";
import { Controller, useForm } from "react-hook-form";
import BaseInputMui from "components/base-input-mui";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import "dayjs/locale/ja";
import { LuArrowRightToLine } from "react-icons/lu";
import { ROUTERS } from "constants/routes.constant";
import BaseConfirmDialog from "components/base-confirm-dialog";
import BaseRejectReason from "components/base-reject-reason";
import { Row, Upload } from "antd";
import { UploadFile } from "antd/lib";
import { InboxOutlined } from "@ant-design/icons";
import BaseModalPreviewPdf from "components/base-preview-pdf";
import { Auth, Storage } from "aws-amplify";
dayjs.locale("ja");

const ConfirmTemporaryRequestView = (): ReactElement => {
  const navigate = useNavigate();
  const theme = useTheme();
  const datePickerFormat = "YYYY/MM/DD HH:mm";
  const [searchParams] = useSearchParams();
  const id = searchParams.get("task_id");
  const requestMailId = searchParams.get("request_mail_id");
  const email = searchParams.get("email_access");
  const { state } = useLocation();
  const [loading, setLoading] = useState<boolean>(false);
  const [dataTask, setDataTask] = useState<TypeCommon>();
  const [dateArr, setDateArr] = useState<TypeCommon>([0]);
  const [rejectReason, setRejectReason] = useState<string>("");
  const [openRejectTaskDialog, setOpenRejectTaskDialog] = useState(false);
  const [invalidType, setInvalidType] = useState<boolean>(false);
  const [maxSize, setMaxSize] = useState<boolean>(false);
  const [maxCount, setMaxCount] = useState<boolean>(false);
  const [estimateFileList, setEstimateFileList] = useState<TypeCommon>([]);
  const [estimatePreviewPdf, setEstimatePreviewPdf] = useState<string>("");
  const [estimatePreviewUrl, setEstimatePreviewUrl] = useState<string>("");
  const [isEstimatePreviewOpen, setIsEstimatePreviewOpen] = useState<boolean>(false);
  const [previewUrls, setPreviewUrls] = useState<TypeCommon[]>([]);

  const FormLabel = ({
    label,
    required,
  }: {
    label: string;
    required?: boolean;
  }): ReactElement => (
    <Typography variant="body2" component="span" fontWeight="600">
      {label}
      {required && <span className="required-field">* </span>}
    </Typography>
  );

  const updateDateArrBudget = (index: number, budget: number): void => {
    setDateArr((prevDateArr: TypeCommon) => {
      if (!prevDateArr || !Array.isArray(prevDateArr)) return prevDateArr;

      const updatedDateArr = [...prevDateArr];
      if (updatedDateArr[index]) {
        updatedDateArr[index] = {
          ...updatedDateArr[index],
          budget: budget
        };
      }
      return updatedDateArr;
    });
  };

  const {
    control,
    getValues,
    setValue,
    handleSubmit,
    clearErrors,
    formState: { errors },
  } = useForm<TypeCommon>({
    defaultValues: {},
    mode: "all",
  });

  // const isWithinWorkTime = (
  //   start: dayjs.Dayjs | string | null,
  //   end: dayjs.Dayjs | string | null,
  // ): boolean => {
  //   if (!start || !end) return false;
  //   const s = dayjs(start);
  //   const e = dayjs(end);
  //   const startHour = s.hour() + s.minute() / 60;
  //   const endHour = e.hour() + e.minute() / 60;
  //   return startHour >= 8 && endHour <= 17.5;
  // };
  const getFileFromS3 = async (keys: TypeCommon[]): Promise<void> => {
    const values = keys?.map((item: TypeCommon) => item?.url);
    const listImg = [];
    const listPdf = [];
    for (const item of values) {
      const result = await Storage.get(item);
      if (result) {
        const extension = item?.split(".").pop();
        if (extension?.includes("pdf")) {
          listPdf?.push({
            name: item?.split("/").pop(),
            nameValue: item,
            url: result,
          });
        } else {
          listImg?.push(result);
        }
      }
    }
    setPreviewUrls(listImg);
    setEstimateFileList(listPdf);
  };
  const handleGetTaskInfo = async (): Promise<void> => {
    try {
      if (!id) return;
      setLoading(true);

      // Get task data and wait for the response
      const res = await get(
        "mail",
        "/mail/detail-task",
        {
          task_id: id,
        },
        null,
        `Bearer ${state?.token}`,
      );

      if (!res?.data) {
        ToastMessage(
          NOTIFICATION_TYPE.ERROR,
          res?.data?.message ?? t("alert-message.failure"),
        );
        return;
      }

      // if (res?.data?.progress_status === TASK_PROGRESS_STATUS_ENUM.REJECTED) {
      //   setLoading(false);
      //   navigate(ROUTERS.MAIL_NOT_FOUND);
      //   return;
      // }

      setDataTask(res?.data);
      setValue("subject", "臨時警備依頼の件");
      setValue("storeName", res?.data?.store_name ?? "");
      setValue("manager_name", res?.data?.manager_name ?? "");
      setValue("responsible_name", res?.data?.responsible_name ?? "");
      setValue(
        "responsible_phone",
        res?.data?.responsible_phone ?? "",
      );
      const timeList = res?.data?.task_time_list?.filter(
        (item: TypeCommon) =>
          Number(item.number_of_guards) > 0 &&
          checkTimeListInWorkingHours(
            [
              {
                start_date: item.start_date,
                end_date: item.end_date,
              },
            ],
            res?.data?.store_id_data?.opening_time,
            res?.data?.store_id_data?.closing_time,
          ),
      );
      if (timeList?.length > 0) {
        const items = timeList.map((time: TypeCommon, index: number) => {
          setValue(`id_${index}`, time?.id);
          setValue(`startDate_${index}`, dayjs(time?.start_date));
          setValue(`endDate_${index}`, dayjs(time?.end_date));
          setValue(`requiredPersons_${index}`, time?.number_of_guards);
          setValue(`workDetails_${index}`, time?.work_details || "");
          setValue(`budget_${index}`, formatNumberWithCommas(time?.budget) || "");
          return {
            ...time,
            budget: time?.budget ? Number(time?.budget) : 0
          };
        });
        setDateArr(items);
      }
      getFileFromS3(res?.data?.attachments ?? []);
    } catch (error: any) {
      ToastMessage(
        NOTIFICATION_TYPE.ERROR,
        error?.response?.data?.message ?? t("alert-message.failure"),
      );
    } finally {
      setLoading(false);
    }
  };
  const handleConfirmMail = async (): Promise<void> => {
    try {
      if (!id || !requestMailId) return;
      const temp: TypeCommon = [];
      setLoading(true);

      if (estimateFileList?.length > 0) {
        const user = await Auth.currentCredentials();
        const id = user?.identityId;
        for (let index = 0; index < estimateFileList.length; index += 1) {
          const file = estimateFileList[index]?.originFileObj;
          if (file) {
            const imageName = `protected/${id}/${file?.name}`;
            try {
              const data = await Storage.put(file?.name, file, {
                level: "protected",
                contentType: file?.type,
              });
              temp.push(`protected/${id}/${data?.key}`);
            } catch (error) {
              await uploadImage(imageName, file);
              temp.push(imageName);
            }
          } else temp.push(estimateFileList[index]?.nameValue);
        }
      }

      // Get task data and wait for the response
      await post(
        "mail",
        "/mail/confirm",
        {
          email_access: email,
          task_id: id,
          request_mail_id: Number(requestMailId),
          page_id: `${ROUTERS.CONFIRM_TEMPORARY_REQUEST_DETAIL}?task_id=${id}`,
          date_ranges: dateArr?.map((item: TypeCommon, index: number) => ({
            id: getValues(`id_${index}`) ?? "",
            startDate: getValues(`startDate_${index}`)?.format(
              "YYYY-MM-DD HH:mm:ss",
            ),
            endDate: getValues(`endDate_${index}`)?.format(
              "YYYY-MM-DD HH:mm:ss",
            ),
            requiredPersons: getValues(`requiredPersons_${index}`),
            workDetails: getValues(`workDetails_${index}`) ?? "",
            budget: item?.budget ?? 0,
          })),
          estimate_file_url: temp,
        },
        null,
        null,
        `Bearer ${state?.token}`,
      );
      await handleGetTaskInfo();
      ToastMessage(
        NOTIFICATION_TYPE.SUCCESS,
        t("alert-message.task6-create-success"),
      );
    } catch (error: any) {
      ToastMessage(
        NOTIFICATION_TYPE.ERROR,
        error?.response?.data?.message ?? t("alert-message.failure"),
      );
    } finally {
      setLoading(false);
    }
  };
  const handleRejectTaskSubmit = async (): Promise<void> => {
    try {
      if (!id || !requestMailId) return;
      setLoading(true);

      // Get task data and wait for the response
      await post(
        "mail",
        "/mail/reject",
        {
          email_access: email,
          task_id: id,
          request_mail_id: Number(requestMailId),
          page_id: `${ROUTERS.CONFIRM_TEMPORARY_REQUEST_DETAIL}?task_id=${id}`,
          reject_reason: rejectReason?.trim() ?? "",
          date_ranges: dateArr?.map((item: TypeCommon, index: number) => ({
            id: getValues(`id_${index}`) ?? "",
            startDate: getValues(`startDate_${index}`)?.format(
              "YYYY-MM-DD HH:mm:ss",
            ),
            endDate: getValues(`endDate_${index}`)?.format(
              "YYYY-MM-DD HH:mm:ss",
            ),
            requiredPersons: getValues(`requiredPersons_${index}`),
            workDetails: getValues(`workDetails_${index}`) ?? "",
            budget: item?.budget ?? 0,
          })),
        },
        null,
        null,
        `Bearer ${state?.token}`,
      );
      await handleGetTaskInfo();
      setRejectReason("");
      setOpenRejectTaskDialog(false);
      ToastMessage(
        NOTIFICATION_TYPE.SUCCESS,
        t("alert-message.task6-create-success"),
      );
    } catch (error: any) {
      ToastMessage(
        NOTIFICATION_TYPE.ERROR,
        error?.response?.data?.message ?? t("alert-message.failure"),
      );
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (!state?.token) {
      navigate(
        `${ROUTERS.CONFIRM_EMAIL_CODE}?task_id=${id ?? ""}&request_mail_id=${requestMailId ?? ""}`,
      );
      return;
    }
    handleGetTaskInfo();
  }, [id, state?.token]);

  useEffect(() => { }, [dateArr]);

  const isActiveRequestMail = (!dataTask?.task_request_mail?.is_approved &&
  !dataTask?.task_request_mail?.is_rejected)

  return (
    <>
      {loading && <Spinner isFullWidth={true} />}
      <Box className="flex-1 flex flex-col gap-5 mt-[80px] mb-5 bg-white rounded-lg px-5 py-10 w-full sm:w-[90%] md:w-[80%] lg:w-[70%]">
        <Typography
          variant="h5"
          component="span"
          fontWeight="bold"
          className="flex justify-center w-full !mb-8"
        >
          臨時警備依頼内容のご確認
        </Typography>
        <Grid container spacing={2}>
          <Grid size={6}>
            <Box className="flex">
              <span className="w-[80px]">宛先</span>
              <span className="font-bold">
                {dataTask?.task_request_mail?.request_mail_detail
                  ?.recipient_company ?? ""}
              </span>
            </Box>
          </Grid>
          <Grid size={6}>
            <Box className="flex">
              <span className="w-[80px]">御中</span>
              <span>{`${dataTask?.task_request_mail?.request_mail_detail
                  ?.recipient_name ?? ""
                } 様`}</span>
            </Box>
          </Grid>
        </Grid>
        <Box className="flex flex-col">
          <span>平素より大変お世話になっております。</span>
        </Box>
        {dataTask?.task_request_mail?.reject_reason && (
          <BaseRejectReason
            content={dataTask?.task_request_mail?.reject_reason}
          />
        )}
        <Box>
          <span className="text-[16px] block !mb-2">発信情報</span>
          <hr />
        </Box>
        <Grid container spacing={2}>
          <Grid size={12}>
            <Box className="flex">
              <span className="w-[80px]">発信元</span>
              <span className="font-bold">サミット株式会社</span>
            </Box>
          </Grid>
          <Grid size={6}>
            <Box className="flex">
              <span className="w-[80px]">担当者</span>
              <span className="font-bold">
                {dataTask?.task_request_mail?.request_mail_detail
                  ?.recipient_name ?? ""}
              </span>
            </Box>
          </Grid>
          <Grid size={6}>
            <Box className="flex">
              <span className="w-[80px]">TEL/FAX</span>
              <span className="font-bold">
                {dataTask?.task_request_mail?.request_mail_detail
                  ?.sender_contact ?? ""}
              </span>
            </Box>
          </Grid>
          <Grid size={12} className="flex flex-col">
            <Typography variant="body2" component="span" fontWeight="bold">
              件名
            </Typography>
            <Controller
              name="subject"
              control={control}
              // rules={{
              //   required: {
              //     value: true,
              //     message: "件名を入力してください",
              //   },
              // }}
              render={({ field }) => (
                <BaseInputMui
                  {...field}
                  error={!!errors.subject}
                  fullWidth
                  // required
                  margin="dense"
                  className="custom-input-field"
                  // helperText={
                  //   control._formState.errors["subject"]?.message as string
                  // }
                  inputProps={{
                    maxLength: 100,
                    readOnly: true,
                  }}
                />
              )}
            />
          </Grid>
        </Grid>
        <Box>
          <span className="text-[16px] whitespace-pre-line">
            以下の通り、臨時警備のご依頼内容をご確認の上、問題がなければ「承認」ボタンを押してください。
          </span>
          <span className="text-[16px] block !mb-2 whitespace-pre-line">
            ご不明点や修正が必要な点がある場合は、「差し戻し」ボタンをご利用ください。
          </span>
          <hr />
        </Box>
        <Box component="form" autoComplete="off">
          <Grid container spacing={2}>
            <Grid size={12} className="flex flex-col">
              <Typography variant="body2" component="span" fontWeight="bold">
                店舗名
              </Typography>
              <Controller
                name="storeName"
                control={control}
                // rules={{
                //   required: {
                //     value: true,
                //     message: "店舗名を入力してください",
                //   },
                // }}
                render={({ field }) => (
                  <BaseInputMui
                    {...field}
                    error={!!errors.storeName}
                    fullWidth
                    // required
                    margin="dense"
                    className="custom-input-field"
                    // helperText={
                    //   control._formState.errors["storeName"]?.message as string
                    // }
                    inputProps={{
                      maxLength: 100,
                      readOnly: true,
                    }}
                  />
                )}
              />
            </Grid>
            <Grid size={12} className="flex flex-col">
              <Typography variant="body2" component="span" fontWeight="bold">
                工事取引先名
              </Typography>
              <Controller
                name="manager_name"
                control={control}
                // rules={{
                //   required: {
                //     value: true,
                //     message: "店舗名を入力してください",
                //   },
                // }}
                render={({ field }) => (
                  <BaseInputMui
                    {...field}
                    error={!!errors.storeName}
                    fullWidth
                    // required
                    margin="dense"
                    className="custom-input-field"
                    // helperText={
                    //   control._formState.errors["storeName"]?.message as string
                    // }
                    inputProps={{
                      maxLength: 100,
                      readOnly: true,
                    }}
                  />
                )}
              />
            </Grid>
            <Grid size={6} className="flex flex-col">
              <Typography variant="body2" component="span" fontWeight="bold">
                担当者名
              </Typography>
              <Controller
                name="responsible_name"
                control={control}
                // rules={{
                //   required: {
                //     value: true,
                //     message: "店舗名を入力してください",
                //   },
                // }}
                render={({ field }) => (
                  <BaseInputMui
                    {...field}
                    error={!!errors.responsible_name}
                    fullWidth
                    // required
                    margin="dense"
                    className="custom-input-field"
                    // helperText={
                    //   control._formState.errors["storeName"]?.message as string
                    // }
                    inputProps={{
                      maxLength: 500,
                      readOnly: true,
                    }}
                  />
                )}
              />
            </Grid>
            <Grid size={6} className="flex flex-col">
              <Typography variant="body2" component="span" fontWeight="bold">
                担当者連絡先
              </Typography>
              <Controller
                name="responsible_phone"
                control={control}
                // rules={{
                //   required: {
                //     value: true,
                //     message: "店舗名を入力してください",
                //   },
                // }}
                render={({ field }) => (
                  <BaseInputMui
                    {...field}
                    error={!!errors.responsible_phone}
                    fullWidth
                    // required
                    margin="dense"
                    className="custom-input-field"
                    // helperText={
                    //   control._formState.errors["storeName"]?.message as string
                    // }
                    inputProps={{
                      maxLength: 500,
                      readOnly: true,
                    }}
                  />
                )}
              />
            </Grid>
            {dateArr?.map((item: TypeCommon, index: number) => {
              return (
                <Grid
                  container
                  spacing={2}
                  className="w-full"
                  key={item?.id || index}
                  sx={{
                    border: `1px solid ${theme.palette.divider}`,
                    borderRadius: 2,
                    p: 2,
                  }}
                >
                  <Grid size={{ xs: 5.5, md: 3.5 }} className="flex flex-col">
                    <Typography
                      variant="body2"
                      component="span"
                      fontWeight="bold"
                    >
                      日時
                    </Typography>
                    <LocalizationProvider
                      dateAdapter={AdapterDayjs}
                      adapterLocale="ja"
                    >
                      <Controller
                        name={`startDate_${index}`}
                        control={control}
                        rules={{
                          required: {
                            value: true,
                            message: "この項目は必要です。",
                          },
                          validate: (value) => {
                            const endDate = getValues(`endDate_${index}`);
                            if (
                              value &&
                              endDate &&
                              dayjs(value).isAfter(dayjs(endDate))
                            ) {
                              return "開始日時は終了日時より前である必要があります。";
                            }
                            return true;
                          },
                        }}
                        render={({ field, fieldState }) => (
                          <DateTimePicker
                            ampm={false}
                            format={datePickerFormat}
                            value={field.value}
                            onChange={(date) => {
                              if (date && date.isValid()) {
                                field.onChange(date);
                              } else {
                                field.onChange(null);
                              }
                            }}
                            // minDateTime={dayjs()}
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                size: "small",
                                placeholder: datePickerFormat,
                                error: !!fieldState.error,
                                helperText: fieldState.error?.message,
                              },
                              actionBar: {
                                actions: [],
                              },
                            }}
                            readOnly
                            slots={{
                              toolbar: () => null,
                            }}
                            closeOnSelect={true}
                            className="custom-input-field"
                            sx={{ marginTop: "8px" }}
                          />
                        )}
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid size={1} className="flex justify-center">
                    <LuArrowRightToLine className="text-[18px] !h-[100px]" />
                  </Grid>
                  <Grid size={{ xs: 5.5, md: 3.5 }} className="flex flex-col">
                    <Typography
                      variant="body2"
                      component="span"
                      fontWeight="bold"
                      className="invisible"
                    >
                      日時
                    </Typography>
                    <LocalizationProvider
                      dateAdapter={AdapterDayjs}
                      adapterLocale="ja"
                    >
                      <Controller
                        name={`endDate_${index}`}
                        control={control}
                        rules={{
                          required: {
                            value: true,
                            message: "この項目は必要です。",
                          },
                          validate: (value) => {
                            const startDate = getValues(`startDate_${index}`);
                            if (
                              value &&
                              startDate &&
                              dayjs(value).isBefore(dayjs(startDate))
                            ) {
                              return "終了日時は開始日時より後である必要があります。";
                            }
                            return true;
                          },
                        }}
                        render={({ field, fieldState }) => (
                          <DateTimePicker
                            ampm={false}
                            format={datePickerFormat}
                            value={field.value}
                            onChange={(date) => {
                              if (date && date.isValid()) {
                                field.onChange(date);
                              } else {
                                field.onChange(null);
                              }
                            }}
                            // minDateTime={dayjs()}
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                size: "small",
                                placeholder: datePickerFormat,
                                error: !!fieldState.error,
                                helperText: fieldState.error?.message,
                              },
                              actionBar: {
                                actions: [],
                              },
                            }}
                            slots={{
                              toolbar: () => null,
                            }}
                            readOnly
                            closeOnSelect={true}
                            className="custom-input-field"
                            sx={{ marginTop: "8px" }}
                          />
                        )}
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid size={{ xs: 12, md: 4 }} className="flex flex-col">
                    <Typography
                      variant="body2"
                      component="span"
                      fontWeight="bold"
                    >
                      警備員必要人数
                    </Typography>
                    <Controller
                      name={`requiredPersons_${index}`}
                      control={control}
                      rules={{
                        required: {
                          value: true,
                          message: "警備員必要人数を選択してください",
                        },
                        // validate: (value) => {
                        //   if (Number(value) <= 0) {
                        //     return "1以上の数字を入力してください";
                        //   }
                        //   return true;
                        // },
                      }}
                      render={({ field }) => (
                        <BaseInputMui
                          {...field}
                          placeholder="警備員必要人数を入力"
                          error={!!errors[`requiredPersons_${index}`]}
                          fullWidth
                          required
                          margin="dense"
                          className="custom-input-field"
                          helperText={
                            control._formState.errors[
                              `requiredPersons_${index}`
                            ]?.message as string
                          }
                          inputProps={{
                            maxLength: 2,
                            readOnly: true,
                          }}
                          onChange={(e) => {
                            const raw = e.target.value;
                            const digitsOnly = raw.replace(/\D/g, "");
                            field.onChange(digitsOnly);
                          }}
                          onBlur={(e: TypeCommon) => {
                            const raw = e.target.value;
                            if (raw) {
                              const digitsOnly = Number(raw);
                              field.onChange(digitsOnly);
                            }
                          }}
                        />
                      )}
                    />
                  </Grid>
                  <Grid size={12} className="flex flex-col">
                    <Typography
                      variant="body2"
                      component="span"
                      fontWeight="bold"
                      className="!mb-[8px]"
                    >
                      作業内容
                    </Typography>
                    <Controller
                      name={`workDetails_${index}`}
                      control={control}
                      render={({ field }) => (
                        <TextareaAutosize
                          minRows={3}
                          maxLength={1000}
                          placeholder="作業内容を入力"
                          className={`custom-textarea`}
                          readOnly
                          {...field}
                        />
                      )}
                    />
                  </Grid>
                  {dataTask?.task_request_mail?.request_mail_detail
                    ?.is_quotation ? (
                    <Grid size={12} className="flex flex-col">
                      <Typography
                        variant="body2"
                        component="span"
                        fontWeight="bold"
                      >
                        見積金額（税抜き）
                        <span className="required-field">* </span>
                      </Typography>
                      <Controller
                        name={`budget_${index}`}
                        control={control}
                        rules={{
                          required: {
                            value: true,
                            message: "見積金額（税抜き）を入力してください",
                          },
                        }}
                        render={({ field }) => {
                          return (
                            <BaseInputMui
                              value={field.value}
                              onChange={(e) => {
                                const maxLength = 10;
                                let rawValue = e.target.value.replace(/,/g, "");
                                // Cho phép cả số 0-9 halfwidth và fullwidth
                                rawValue = rawValue.replace(/[^\d\uFF10-\uFF19]/g, "");
                                // Chuyển fullwidth sang halfwidth
                                // rawValue = normalizeFullwidthToHalfwidth(rawValue);
                                rawValue = rawValue.slice(0, maxLength);
                                // Format với dấu phẩy ngay lúc onChange
                                // const formatted = rawValue
                                //   ? rawValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                                //   : "";
                                // setDisplayValue(formatted);
                                // field.onChange chỉ nhận số thuần
                                field.onChange(rawValue);
                              }}
                              onBlur={() => {
                                // Convert fullwidth to halfwidth first
                                const halfwidthValue = field.value ? normalizeFullwidthToHalfwidth(field.value) : "";
                                // Then format with commas
                                const formatted = halfwidthValue
                                  ? halfwidthValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                                  : "";
                                field.onChange(formatted);
                                // Cập nhật dateArr với giá trị budget đã format
                                const numericValue = formatted ? Number(formatted.replace(/,/g, "")) : 0;
                                updateDateArrBudget(index, numericValue);
                              }}
                              placeholder="見積金額（税抜き）を入力"
                              error={!!errors[`budget_${index}`]}
                              fullWidth
                              required
                              margin="dense"
                              className="custom-input-field"
                              helperText={
                                control._formState.errors[`budget_${index}`]
                                  ?.message as string
                              }
                              type="tel"
                              inputProps={{
                                step: "any",
                                inputMode: "numeric",
                                maxLength: 15, // 10 số + 5 dấu phẩy
                                pattern: "[0-9]*",
                                autoComplete: "off",
                                autoCorrect: "off",
                                autoCapitalize: "off",
                                spellCheck: "false",
                                readOnly: !(
                                  !dataTask?.task_request_mail?.is_approved &&
                                  !dataTask?.task_request_mail?.is_rejected
                                ),
                              }}
                            />
                          );
                        }}
                      />
                    </Grid>
                  ) : (
                    <></>
                  )}
                </Grid>
              );
            })}
            <Grid size={12}>
              <FormLabel label="見積書（ハードコピー）" />
              <Row className="w-full h-full flex flex-col justify-center">
                <Controller
                  name="estimateFileUrl"
                  control={control}
                  render={({ field, fieldState: { error } }) => (
                    <>
                      <Upload.Dragger
                        name="estimateFileUrl"
                        multiple={false}
                        listType="picture-card"
                        accept={".pdf"}
                        disabled={!isActiveRequestMail}
                        beforeUpload={(file): boolean => {
                          if (!file.type.includes("pdf")) {
                            setInvalidType(true);
                          }
                          if (file.size > 50 * 1024 * 1024) {
                            // 50MB
                            setMaxSize(true);
                            ToastMessage(
                              NOTIFICATION_TYPE.ERROR,
                              "５０Mb以下のファイルを選択してください。",
                            );
                            return false;
                          }
                          return false;
                        }}
                        fileList={estimateFileList}
                        onChange={(info): void => {
                          // Only keep the latest file and only if it's a PDF and <= 50MB
                          const filtered = info?.fileList
                            ?.filter(
                              (item: UploadFile) =>
                                item?.type?.includes("pdf") &&
                                (item?.size ?? 0) <= 50 * 1024 * 1024,
                            )
                            ?.slice(-1); // Only keep the last file
                          const newFileList = filtered?.map(
                            (item: TypeCommon) => {
                              return {
                                ...item,
                                url: URL.createObjectURL(item.originFileObj),
                              };
                            },
                          );

                          setEstimateFileList(newFileList);

                          field.onChange(
                            newFileList?.length ? newFileList : null,
                          );
                          clearErrors("estimateFileUrl");
                        }}
                        className={
                          error
                            ? "custom-upload-dragger error"
                            : "custom-upload-dragger"
                        }
                        style={{ minHeight: '200px', maxHeight: '200px' }}
                        onPreview={async (file) => {
                          if (file?.originFileObj) {
                            const fileData = file?.originFileObj as File;
                            if (fileData?.type?.includes("pdf")) {
                              setEstimatePreviewPdf(
                                window.URL.createObjectURL(fileData) || "",
                              );
                              setEstimatePreviewUrl("");
                            } else {
                              setEstimatePreviewUrl(
                                window.URL.createObjectURL(fileData) || "",
                              );
                              setEstimatePreviewPdf("");
                            }
                          } else {
                            setEstimatePreviewUrl("");
                            setEstimatePreviewPdf(file?.url || "");
                          }
                          setIsEstimatePreviewOpen(true);
                        }}
                        onDrop={(): void => {
                          setMaxCount(false);
                          setInvalidType(false);
                          setMaxSize(false);
                        }}
                        showUploadList={{
                          showRemoveIcon: isActiveRequestMail,
                        }}
                      >
                        <Row
                          className="flex flex-col px-5"
                          style={{ width: "100%", textAlign: "center" }}
                        >
                          <p
                            className="ant-upload-drag-icon"
                            style={{ fontSize: 48, color: "#1890ff" }}
                          >
                            <InboxOutlined />
                          </p>
                          <p
                            className="ant-upload-text"
                            style={{ fontSize: 16, margin: 0 }}
                          >
                            PDFファイルをアップデート項目
                          </p>
                          <p
                            className="ant-upload-text font-bold"
                            style={{ fontSize: 14, color: "#888" }}
                          >
                            【最大1ファイル・最大50MB】
                          </p>
                        </Row>
                      </Upload.Dragger>
                      {error && (
                        <p style={{ color: "red", fontSize: 12 }}>
                          {error.message}
                        </p>
                      )}
                    </>
                  )}
                />
              </Row>
            </Grid>

            {isActiveRequestMail && (
                <>
                  <Grid size={12} sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                    <Button
                      variant="contained"
                      size="large"
                      onClick={handleSubmit(() => setOpenRejectTaskDialog(true))}
                      className="!bg-[#FC1212] hover:opacity-80 !h-[40px] !rounded-[10px]"
                    >
                      差し戻し
                    </Button>
                    <Button
                      variant="contained"
                      size="large"
                      onClick={handleSubmit(handleConfirmMail)}
                      className="!bg-[#00A651] hover:opacity-80 !h-[40px] !rounded-[10px] !min-w-[104px]"
                    >
                      承認
                    </Button>
                  </Grid>
                </>
              )}
          </Grid>
        </Box>
      </Box>
      {isEstimatePreviewOpen && (
        <BaseModalPreviewPdf
          openModal={isEstimatePreviewOpen}
          handleCloseModal={() => setIsEstimatePreviewOpen(false)}
          url={estimatePreviewPdf}
        />
      )}
      <BaseConfirmDialog
        open={openRejectTaskDialog}
        title="差し戻し"
        content={
          <Typography variant="body2" component="span" fontWeight="600">
            差し戻し理由
            <span className="required-field">* </span>
          </Typography>
        }
        onClose={() => setOpenRejectTaskDialog(false)}
        onConfirm={handleRejectTaskSubmit}
        confirmText="差し戻し"
        cancelText="キャンセル"
        loading={loading}
        showTextarea={true}
        textareaLabel="理由"
        textareaPlaceholder="差し戻し理由を入力してください"
        textareaValue={rejectReason}
        onTextareaChange={setRejectReason}
        textareaRequired={true}
      />
    </>
  );
};

export default ConfirmTemporaryRequestView;
